// @flow
import { decorate, observable, action, runInAction } from 'mobx';
import gqlUtils from '@mqd/graphql-utils';
import BusinessDirectorStore from './../stores/BusinessDirectorStore';
import { ParentTableStore } from '@mq/voltron-parent';

const { fragments } = gqlUtils;

export default class BusinessDirectorsTableStore extends ParentTableStore {
  constructor(args: Object = {}) {
    super(args);
    this.load(args);
  }
  // values
  items: Array<BusinessDirectorStore> = [];
  count: number = 50;
  business_token: string = '';
  activeRow: BusinessDirectorStore = null;
  editDirectorActive: boolean = false;

  // actions
  handleSearch() {
    const { hydrate, setAttr } = this;
    setAttr && setAttr('start_index', 0);
    setAttr('count', 50);
    hydrate && hydrate();
  }

  async hydrate() {
    if (!this.enableNoParamQuery && !this.haveRequiredParams) return;
    this.loading = true;

    const result = await this.gqlQuery(
      `
        query directors${this.outerQueryParams} {
          directors${this.innerQueryParams} {
            data {
              ...directorBaseInfo
            }
            ${this.paginationAttributes}
          }
        }

        ${fragments.directorBaseInfo}
      `,
      {
        count: this.count,
        start_index: this.start_index,
        business_token: this.business_token,
      }
    );

    runInAction(() => {
      const directors = this.extract(result, 'directors');
      this.processPaginationResponse(directors, BusinessDirectorStore);
      this.loading = false;
    });
  }
}

decorate(BusinessDirectorsTableStore, {
  // values
  items: observable,
  count: observable,
  business_token: observable,
  activeRow: observable,
  editDirectorActive: observable,

  // actions
  hydrate: action.bound,
  handleSearch: action.bound,
});
